module.exports = __webpack_public_path__ + "static/media/infoJumbo3.9fe9da42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/loewer/images/infoJumbo3.png
// module id = 521
// module chunks = 0